import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	imports: [TranslateModule],
})
export class FileUploadComponent {
	public uploadedFile: File | null = null;

	@Input() public multiple = false;
	@Input() public imagesExtension: string[] = [];
	@Input() public disabled: boolean = false;
	@Input() public label = 'file-upload.file';

	@Output() public fileChange: EventEmitter<File | null> = new EventEmitter<File | null>();

	@ViewChild('f', { static: true }) public fileUploader!: ElementRef;

	get fileNames(): string {
		if (this.uploadedFile instanceof File) {
			return this.uploadedFile.name;
		} else {
			return '';
		}
	}

	set selectedFile(file: File[]) {
		if (file) {
			this.uploadedFile = file[0];
		} else {
			this.uploadedFile = null;
		}
		this.fileChange.emit(this.uploadedFile);
	}

	get filesType(): string {
		return this.imagesExtension.map((v) => '.' + v).join(',');
	}

	reset(): void {
		this.uploadedFile = null;
		this.fileUploader.nativeElement.value = null;
	}
}
